import useFetch from "./useFetch";
import usePost from "./usePost";
import usePut from "./usePut";
import useDelete from "./useDelete";

const useCrud = (endpoint) => {
  const fetch = useFetch(endpoint);
  const post = usePost(endpoint);
  const put = usePut(endpoint);
  const del = useDelete(endpoint);

  const clearErrors = () => {
    fetch.setError(null);
    post.setError(null);
    put.setError(null);
    del.setError(null);
  };

  return {
    fetchData: fetch.data,
    fetchLoading: fetch.loading,
    fetchError: fetch.error,
    refetch: fetch.refetch,
    postData: post.postData,
    postLoading: post.loading,
    postError: post.error,
    putData: put.putData,
    putLoading: put.loading,
    putError: put.error,
    deleteData: del.deleteData,
    deleteLoading: del.loading,
    deleteError: del.error,
    clearErrors,
  };
};

export default useCrud;
